import React from "react";
import FooterTwo from "../../components/FooterTwo";
import BottomFooter from "../../components/BottomFooter";
import Breadcrumb from "../../components/Breadcrumb";
import HeaderTwo from "../../components/HeaderTwo";
import Preloader from "../../helper/Preloader";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../../helper/ColorInit";
import UserGaurd from "../../helper/AuthGaurd";
import TextInput from "../../components/TextInput";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { handleError } from "../../utils/functions";
import axiosInstance from "../../config/axios.config";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const schema = yup.object({
  oldPassword: yup.string().required("Old Password is required"),
  newPassword: yup.string().required("New Password is required"),
  confirmPassword: yup.string().required("Confirm Password is required"),
});

const Password = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
  });

  const onSubmit = async (values) => {
    try {
      const { data } = await axiosInstance.post("/user/change-password", values);
      if (!data.error) {
        toast.success(data.message);
        reset();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <UserGaurd>
      <ColorInit color={true} />
      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Change Password"} />

      <div className="container">
        <div className="row mt-20 justify-content-center">
          <div className="col-md-7">
            <div className="card">
              <div className="card-body py-50 px-20">
                <div className="text-center">
                  <h5 className="text-center">{t("changePasswords")}</h5>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="col-12">
                      <TextInput
                        name={"oldPassword"}
                        label={t("currentPassword")}
                        type={"password"}
                        className="mb-20"
                        register={register}
                        error={errors.oldPassword}
                        placeholder={t("enterCurrentPassword")}
                        isRequired
                        hasicon
                      />
                    </div>
                    <div className="col-12">
                      <TextInput
                        name={"newPassword"}
                        label={t("newPassword")}
                        type={"password"}
                        className="mb-20"
                        register={register}
                        error={errors.newPassword}
                        placeholder={t("enterNewPassword")}
                        isRequired
                        hasicon
                      />
                    </div>
                    <div className="col-12">
                      <TextInput
                        name={"confirmPassword"}
                        label={t("confirmPassword")}
                        type={"password"}
                        className="mb-20"
                        register={register}
                        error={errors.confirmPassword}
                        placeholder={t("enterConfirmPassword")}
                        isRequired
                        hasicon
                      />
                    </div>
                    <div className="col-12 text-center">
                      <button type="submit" className="btn btn-main gap-8 rounded-8 py-16 fw-normal">
                        {t("updatePassword")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FooterTwo */}
      <FooterTwo />

      {/* BottomFooter */}
      <BottomFooter />
    </UserGaurd>
  );
};

export default Password;
